import AsyncStorage from '@react-native-async-storage/async-storage'
import { Mapping, Theme } from './theme.service'

const MAPPING_KEY: string = 'mapping'
const THEME_KEY: string = 'theme'
const NAVIGATION_KEY = 'NAVIGATION_STATE'
const NAME_KEY = 'NAME_KEY'
const EMAIL_KEY = 'EMAIL_KEY'
const PHONE_KEY = 'PHONE_KEY'
const JWT_KEY = 'JWT_KEY'

export class AppStorage {

  static getMapping = async (fallback?: Mapping): Promise<Mapping | null> => {
    const value = await AsyncStorage.getItem(MAPPING_KEY)
    return value as unknown as Mapping
  }

  static getTheme = async (fallback?: Theme): Promise<Theme | null> => {
    const value = await AsyncStorage.getItem(THEME_KEY)
    return value as unknown as Theme
  }

  static getNavigation = async (fallback?: string): Promise<string | null> => {
    const value = await AsyncStorage.getItem(NAVIGATION_KEY)
    return value
  }

  static getJwt = async (fallback?: string): Promise<string | null> => {
    const value = await AsyncStorage.getItem(JWT_KEY)
    return value
  }

  static getName = async (fallback?: string): Promise<string | null> => {
    const value = await AsyncStorage.getItem(NAME_KEY)
    return value
  }

  static getEmail = async (fallback?: string): Promise<string | null> => {
    const value = await AsyncStorage.getItem(EMAIL_KEY)
    return value
  }

  static getPhone = async (fallback?: string): Promise<string | null> => {
    const value = await AsyncStorage.getItem(PHONE_KEY)
    return value
  }

  static setMapping = async (mapping: Mapping): Promise<void> => {
    try {
      await AsyncStorage.setItem(MAPPING_KEY, mapping)
    } catch (e) {
      // saving error
    }
  }

  static setTheme = async (theme: Theme): Promise<void> => {
    try {
      await AsyncStorage.setItem(THEME_KEY, theme)
    } catch (e) {
      // saving error
    }
  }

  static setNavigation = async (navigation: string): Promise<void> => {
    try {
      await AsyncStorage.setItem(NAVIGATION_KEY, navigation)
    } catch (e) {
      // saving error
    }
  }


  static setJwt = async (jwt: string): Promise<void> => {
    try {
      await AsyncStorage.setItem(JWT_KEY, jwt)
    } catch (e) {
      // saving error
    }
  }

  static setName = async (name: string): Promise<void> => {
    try {
      await AsyncStorage.setItem(NAME_KEY, name)
    } catch (e) {
      // saving error
    }
  }

  static setEmail = async (email: string): Promise<void> => {
    try {
      await AsyncStorage.setItem(EMAIL_KEY, email)
    } catch (e) {
      // saving error
    }
  }

  static setPhone = async (phone: string): Promise<void> => {
    try {
      await AsyncStorage.setItem(PHONE_KEY, phone)
    } catch (e) {
      // saving error
    }
  }

  static deleteJwt = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(JWT_KEY)
    } catch (e) {
      // saving error
    }
  }

  static deleteName = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(NAME_KEY)
    } catch (e) {
      // saving error
    }
  }

  static deleteEmail = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(EMAIL_KEY)
    } catch (e) {
      // saving error
    }
  }

  static deletePhone = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(PHONE_KEY)
    } catch (e) {
      // saving error
    }
  }
}
